export default {
  'get-list': {
    method: 'post',
    url: '/vehicle/category/list'
  },
  getAll: {
    method: 'post',
    url: '/vehicle/category/get-all'
  },
  getAllList: {
    method: 'get',
    url: '/vehicle/category/list'
  },
  add: {
    method: 'post',
    url: '/vehicle/category'
  },
  delete: {
    url: '/vehicle/category',
    method: 'delete'
  },
  getById: {
    url: '/vehicle/category/ID',
    method: 'get'
  },
  edit: {
    url: '/vehicle/category/ID',
    method: 'put'
  },
  find: {
    method: 'get',
    url: '/vehicle/category/find?key=KEY&vehicleLoad=vehicleLoadData&QUERY'
  },
  'find-by-vehicle-tonnage': {
    method: 'get',
    url: '/vehicle/category/find-by-vehicle-tonnage?key=KEY'
  },
  lastCategory: {
    method: 'get',
    url: '/vehicle/category/last-category'
  }
}
